import BoxWrap1Props from "./BoxWrap1Props.interface";
import setStyles from "./helpers/setStyles";
import styles from "./BoxWrap1.module.scss";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent } from "react";

// eslint-disable-next-line react/display-name
const BoxWrap1: FunctionComponent<BoxWrap1Props> = React.forwardRef<HTMLDivElement, BoxWrap1Props>((props, ref) => {
    const { containerStyles, containerClasses } = setStyles(props, styles);

    return (
        <div className={combineClasses(styles.wrapper, containerClasses, props.className)} style={containerStyles} ref={ref}>
            <div className={styles.inner}>
                {props.children}
            </div>

            {props.content.backgroundMedia?.[0] && props.content.backgroundMedia.length > 0 ? (
                <div className={styles.background}>
                    <BackgroundMedia {...props.content.backgroundMedia[0]} />
                </div>
            ) : null}
        </div>
    );
});

export default BoxWrap1;